import StarfishRouteHelper from '@/plugins/navigation/router/StarfishRouteHelper';

const starfishRouter = {
  install(Vue) {
    Vue.prototype.$starfishRouter = new StarfishRouteHelper();
  },
};

export default starfishRouter;
